import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { useSYS4090_R01Store } from "./Store_SYS4090_R01";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { useState } from "react";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { SearchDateSingleForm } from "src/components/common/form/search/SearchDateSingleForm";

interface Props {
}

export const SearchSection_SYS4090_R01 = ({
}: Props) => {
  const { SYS4090_R01Filter, setSYS4090_R01Filter } = useSYS4090_R01Store();
  const { bankCdList, bankAcctTypeList, yesNoList } = useCommonCodeStore();
  const [pickerVisible, setPickerVisible] = useState(false);
  const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

  return (
    <SearchSectionForm>
      <SearchDropDownForm<SysCodeDto>
        label="은행코드"
        value={SYS4090_R01Filter.bankCd || 'all'}
        optionList={bankCdList}
        onChangeValue={v => setSYS4090_R01Filter({ bankCd: v === 'all' ? '' : v })}
      />
      <SearchDropDownForm<SysCodeDto>
        label="예적금구분"
        value={SYS4090_R01Filter.acctType || 'all'}
        optionList={bankAcctTypeList}
        onChangeValue={v => setSYS4090_R01Filter({ acctType: v === 'all' ? '' : v })}
      />
      <SearchDropDownForm<SysCodeDto>
        label="만기포함(유효계좌만)"
        value={SYS4090_R01Filter.includeDue}
        optionList={yesNoList}
      
		initLabelLess={true}
        onChangeValue={v => setSYS4090_R01Filter({ includeDue: v === 'Y' ? 'Y' : 'N' })}
      />
      {/* <SearchDateRangeForm
				label="기준일자"
				visible={pickerVisible}						setVisible={setPickerVisible}
				dateRange={SYS4090_R01Filter.baseDate}		setDateRange={(dateRange) => updateSYS4090_R01Filter('baseDate', dateRange)}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/> */}
		
		<SearchDateSingleForm
				label="기준일자"
				visible={pickerVisible}		setVisible={setPickerVisible}
				value={SYS4090_R01Filter.baseDate}
				editable={SYS4090_R01Filter.includeDue === 'N'}
				onChange={(date) => setSYS4090_R01Filter({ baseDate: date })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
      
    </SearchSectionForm>
  );
}; 